/* first we load dependencies */
require('@/bootstrap')
// require('./vue-bootstrap')

/* then main libraries */
import Vue from 'vue'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

import axios from 'axios'
Vue.prototype.$axios = axios

/* then the application's components */
require('@/components/bootstrap')

/* finally, mount the application */
new Vue({
  vuetify,
  // render: h => h(App)
}).$mount('#app')